/* eslint-disable no-param-reassign */
import produce from 'immer';
var genomesError = produce(function (draft) {
  draft.error = true;
});
export default genomesError;